import Spinner from 'components/Spinner'
import dynamic from 'next/dynamic'
import { IProps } from './PageScroll'

const CarouselEl = dynamic(async () => await import('./PageScroll'), {
  ssr: false,
  // eslint-disable-next-line react/display-name
  loading: () => <Spinner />
})

export function NoSSRCarousel(options: IProps) {
  return <CarouselEl {...options} />
}
